import React from 'react'
import healthcare1 from '../images/visitorai1.png';
import healthcare2 from '../images/visitorai2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function VisitorTrackAI() {
  return (
    <>
      <section id="portfolio" className="container my-5">
        <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
          <div className="px-3 fw-bold responsive-heading">
            <span className="highlight-orange">VisitorTrack AI</span> – Smart Web Visitor Intelligence & Behavior Analytics Platform
          </div>
        </div>
      </section>

      <section className="container my-5">

        {/* Section 1: Project Overview */}
        <div className="row g-0 overflow-hidden shadow rounded">
          <div className="col-12 col-md-5">
            <img
              src={healthcare1}
              alt="Visitor Tracking Overview"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>

          <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
            <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
              <span className="highlight-orange">VisitorTrack AI</span> – Real-Time Website Visitor Tracking & Insights Engine
            </h1>

            <p className="mb-3 ps-1">
              VisitorTrack AI is an advanced web intelligence system designed to capture and analyze
              visitor behavior in real-time. It tracks user interactions, browser details, geolocation,
              session duration, and navigation patterns to provide deep actionable insights.
            </p>

            <p className="mb-3 ps-1">
              The platform transforms anonymous traffic into meaningful data, helping businesses
              understand user intent, improve engagement, and optimize conversion strategies through
              data-driven decisions.
            </p>

            {/* ROI Section */}
            <p className="mb-3 ps-1 fw-bold">
              <span className="highlight-orange">Measurable Business Impact & ROI:</span>
            </p>

            <p className="mb-2 ps-3">
              <span className="highlight-orange fw-bold">50–60%</span> improvement in user behavior visibility with real-time tracking and analytics.
            </p>

            <p className="mb-2 ps-3">
              <span className="highlight-orange fw-bold">30–40%</span> increase in conversion rates by identifying high-intent visitors and optimizing funnels.
            </p>

            <p className="mb-2 ps-3">
              <span className="highlight-orange fw-bold">70%</span> better marketing targeting through location, device, and session insights.
            </p>

            <p className="mb-3 ps-3">
              <span className="highlight-orange fw-bold">60%</span> reduction in guesswork with data-backed decision making and user journey tracking.
            </p>

            <p className="mb-4 ps-1">
              VisitorTrack AI empowers businesses with deep visibility into their audience,
              enabling smarter strategies, higher engagement, and faster growth.
            </p>

            <a
              href="/contact-us"
              className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
            >
              Contact Us
            </a>
          </div>
        </div>


        {/* Section 2: Summary */}
        <div className="row g-0 overflow-hidden shadow rounded my-5">
          <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
            <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
              <span className="highlight-orange">Product:</span> VisitorTrack AI
            </h1>

            <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
            <p className="mb-3 ps-3">Global</p>

            <h4 className="fw-bold mb-1 highlight-orange">Technology & Purpose</h4>
            <p className="mb-3 ps-3">
              Web Analytics Engine, Real-Time Tracking, User Behavior Analysis,
              Geolocation Tracking, Session Monitoring, React, Node.js, Firebase,
              REST APIs, Data Visualization Dashboards
            </p>

            <h4 className="fw-bold mb-1 highlight-orange">Domain</h4>
            <p className="mb-3 ps-3">Web Analytics & User Intelligence</p>

            <h4 className="fw-bold mb-1 highlight-orange">Team Involvement</h4>
            <p className="mb-3 ps-3">
              UI/UX Designer, Frontend Developer, Backend Engineer,
              Data Analyst, System Architect
            </p>

            <h4 className="fw-bold mb-1 highlight-orange">Duration</h4>
            <p className="mb-4 ps-3">3 to 5 Months</p>

            <p className="mb-4 ps-3">
              VisitorTrack AI provides a centralized dashboard where businesses can monitor
              every visitor in real time. It captures detailed information such as location,
              device type, browser, pages visited, and session duration.
              <br /><br />
              With intuitive dashboards and analytics, companies can track user journeys,
              identify drop-off points, and improve website performance and engagement.
            </p>

            <a
              href="/contact-us"
              className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
            >
              Contact Us
            </a>
          </div>

          <div className="col-12 col-md-5">
            <img
              src={healthcare2}
              alt="Visitor Analytics Dashboard"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>
        </div>


        {/* Section 3: Process */}
        <div className="row g-0 overflow-hidden shadow rounded my-5">
          <div className="col-12 col-md-5">
            <img
              src={healthcare3}
              alt="Visitor Tracking Features"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>

          <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
            <h1 className="fw-bold mb-3">
              <span className="highlight-orange">Process</span>
            </h1>

            <p className="mb-3 ps-1">
              The platform is built using a lightweight tracking script integrated into websites,
              which collects visitor data securely and processes it in real-time through scalable APIs.
            </p>

            <p className="mb-3 ps-1">
              Data is visualized through interactive dashboards, allowing businesses to monitor
              live visitors, analyze trends, and make informed decisions instantly.
            </p>

            <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
            <ul className="ps-3 mb-4">
              <li className="mb-1">Real-time visitor tracking</li>
              <li className="mb-1">Browser, device & geolocation detection</li>
              <li className="mb-1">Session duration & page tracking</li>
              <li className="mb-1">User journey & behavior analytics</li>
              <li className="mb-1">Live dashboard with actionable insights</li>
            </ul>

            <a
              href="/contact-us"
              className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
            >
              Get Started
            </a>
          </div>
        </div>

        <OurPartner />
      </section>
    </>
  )
}

export default VisitorTrackAI